import { createContext } from 'react';

export interface I18nProvider {
  translate: (x: string) => string;
  changeLocale: (locale: string) => Promise<void>;
  getLocale: () => string;
  addMessages: (x: any) => any;
}

export interface TranslationContextValue {
  locale: string;
  setLocale: (locale: string) => void;
  i18nProvider: I18nProvider | null;
}

export const TranslationContext = createContext<TranslationContextValue>({
  locale: 'en',
  setLocale: () => {},
  i18nProvider: null,
});
